.statusbadge {
  align-items: center;
  background-color: var(--color-grey-200);
  color: var(--color-grey-700);
  display: flex;
  font-family: inherit;
  font-size: var(--font-size-text-non-essential);
  height: 1.5rem;
  padding: 0 0.5rem;
  white-space: nowrap;
  width: fit-content;
}

.statusbadge--high-contrast {
  background-color: var(--color-uva-white);
}
